class Boroughs {
  constructor(map, apiKey) {
    this.map = map;
    this.apiKey = apiKey;

    this.draw();
    this.handleClick();
  }

  draw() {
    const featuresId = "2db8df31-ea45-40cf-8de9-4bb8b29ce14a";

    this.map.addSource("boroughs", {
      type: "geojson",
      data: `https://api.maptiler.com/data/${featuresId}/features.json?key=${this.apiKey}`,
    });

    this.map.addLayer({
      id: "boroughs-fill",
      type: "fill",
      source: "boroughs",
      layout: {},
      minzoom: 8,
      maxzoom: 11,
      paint: {
        "fill-color": "#37FFF3",
        "fill-opacity": 0.6,
      },
    });

    this.map.addLayer({
      id: "boroughs-borders",
      type: "line",
      source: "boroughs",
      layout: {},
      minzoom: 8,
      maxzoom: 11,
      paint: {
        "line-color": "#31B1AA",
        "line-width": 2,
      },
    });
  }

  handleClick() {
    this.map.on("click", "boroughs-fill", (e) => {
      const target = { center: e.lngLat, zoom: 14 };
      this.map.flyTo(target);
    });
  }
}

export default Boroughs;
